module.exports = __webpack_public_path__ + "img/parrallel_0.015721aa.png";